import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IProductXVariant } from "src/models/Products/Product.models";

interface ProductXVariantState {
  productVariants: IProductXVariant[];
  productVariantToEdit: IProductXVariant | null;
}

const initialState: ProductXVariantState = {
  productVariants: [],
  productVariantToEdit: null,
};

const productXVariantSlice = createSlice({
  name: "ProductXVariant",
  initialState,
  reducers: {
    setProductXVariantList: (
      state,
      action: PayloadAction<IProductXVariant[]>
    ) => {
      state.productVariants = action.payload;
    },
    concatListProductXVariant: (
      state: ProductXVariantState,
      action: PayloadAction<IProductXVariant[]>
    ) => {
      state.productVariants = [...state.productVariants.concat(action.payload)];
    },
    setProductXVariantToEdit: (
      state,
      action: PayloadAction<IProductXVariant | null>
    ) => {
      state.productVariantToEdit = action.payload;
    },
    addProductXVariant: (state, action: PayloadAction<IProductXVariant>) => {
      state.productVariants.push(action.payload);
    },
    updateProductXVariant: (state, action: PayloadAction<IProductXVariant>) => {
      let itemIndex = state.productVariants.findIndex(
        item => item.variantId === action.payload.variantId
      );
      if (itemIndex !== -1) state.productVariants[itemIndex] = action.payload;
    },
    deleteProductXVariant: (state, action: PayloadAction<number>) => {
      const newArray = state.productVariants.filter(
        item => item.variantId !== action.payload
      );
      state.productVariants = newArray;
    },
  },
});

export const {
  setProductXVariantList,
  concatListProductXVariant,
  setProductXVariantToEdit,
  addProductXVariant,
  updateProductXVariant,
  deleteProductXVariant,
} = productXVariantSlice.actions;

export default productXVariantSlice.reducer;
